import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { orderBy } from 'lodash';

// @tcc
import { getMessage } from 'util/locale';
import { Icon } from '@tcc/crate';

// components
import ZoneRow from './ZoneRow';

const baseString = 'vra-review-scenarios-zone-table';

const ZoneTable = ({
  areaHeaderText,
  onClickRow,
  rateHeaderText,
  rows,
  yieldHeaderText,
  isDensityToolEnabled = false
}) => {
  const tableClassString = classNames({
    [`${baseString}`]: true,
    'vra-review-scenarios-zone-table-density-tool': isDensityToolEnabled
  });
  const tableHeaderClassString = classNames({
    [`${baseString}--sortable-header`]: true
  });
  const sortIconClassString = classNames({
    [`${baseString}--sort-icon`]: true
  });

  
  const [sortedRows, setSortedRows] = useState(rows);
  const defaultSort = {
    value: 'area',
    iconGlyph: Icon.set.ARROW_UP
  };
  const [sortStatus, setSortStatus] = useState(defaultSort);

  const sortRows = (value) => {
    let order = 'asc';
    let iconGlyph = Icon.set.ARROW_UP;
    if (sortStatus.value === value && sortStatus.iconGlyph === Icon.set.ARROW_UP) {
      order = 'desc';
      iconGlyph = Icon.set.ARROW_DOWN;
    }
    setSortedRows(orderBy(sortedRows, value, order));
    setSortStatus({value, iconGlyph});
  };

  useEffect(() => {
    const order = sortStatus.iconGlyph === Icon.set.ARROW_UP ? 'asc' : 'desc';
    const value = sortStatus.value;
    setSortedRows(orderBy(rows, value, order));
  }, [rows, sortStatus.iconGlyph, sortStatus.value]);

  const rowComponents = sortedRows.map((zoneRow) => (
    <ZoneRow {...zoneRow} key={zoneRow.zoneInternalId} onClickRow={onClickRow} />
  ) );
  return (
    <div>      
      <table className={tableClassString}>
        <thead>
          <tr>
            <th className={tableHeaderClassString} onClick={() => sortRows('zoneId')}>
              {getMessage('zone')}
              {sortStatus.value === 'zoneId' 
                && <Icon className={sortIconClassString} glyph={sortStatus.iconGlyph}/>}
            </th>
            <th className={tableHeaderClassString} onClick={() => sortRows('rate')}>
              {rateHeaderText}
              {sortStatus.value === 'rate' 
                && <Icon className={sortIconClassString} glyph={sortStatus.iconGlyph}/>}
            </th>
            <th className={tableHeaderClassString} onClick={() => sortRows('averageYield')}>
              {yieldHeaderText}
              {sortStatus.value === 'averageYield' 
                && <Icon className={sortIconClassString} glyph={sortStatus.iconGlyph}/>}
            </th>
            <th className={tableHeaderClassString} onClick={() => sortRows('area')}>
              {areaHeaderText}
              {sortStatus.value === 'area' 
                && <Icon className={sortIconClassString} glyph={sortStatus.iconGlyph}/>}
            </th>
          </tr>
        </thead>
        <tbody>
          {rowComponents}
        </tbody>
      </table>
    </div>
  );
};

ZoneTable.propTypes = {
  areaHeaderText:propTypes.string.isRequired,
  isDensityToolEnabled: propTypes.bool.isRequired,
  onClickRow:propTypes.func,
  rateHeaderText:propTypes.string.isRequired,
  rows:propTypes.arrayOf(ZoneRow.propTypes.row).isRequired,
  yieldHeaderText:propTypes.string.isRequired
};

export default ZoneTable;
